export default "__VITE_PUBLIC_ASSET__887f7b06__"